module.exports = __webpack_public_path__ + "static/media/filter.a2c1a078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter.svg
// module id = 881
// module chunks = 0